module.exports = __webpack_public_path__ + "static/media/android_1.fde97028.png";